import React, { useState, useLayoutEffect, useRef } from 'react'

import { GetProducts } from '@web/walter-lib/api'
import Slider from '@ant-design/react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Button, FormattedHTMLMessage } from '@web/walter-ui-kit'
import cn from 'classnames'
import { CardModal } from '../components/Card'
import s from './s.module.css'
import { lang } from './lang'
import { useProducts } from '~api'
import CardImage from '~pages/CardsPage/components/CardImage'

interface Props {
    onContinueClick: (product: GetProducts) => void
}

const sliderSettings = {
    className: 'slider variable-width',
    dots: true,
    infinite: false,
    centerMode: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
}

// eslint-disable-next-line max-lines-per-function
function Mobile({ onContinueClick }: Props) {
    const { data: productsData } = useProducts()
    const [cardModal, setCardModal] = useState(false)
    const [product, setProduct] = useState<GetProducts>()
    const [isSliding, setIsSliding] = useState(false)
    const sliderRef = useRef<Slider | null>(null)

    const products = productsData?.products || []

    useLayoutEffect(() => {
        setProduct(productsData?.products?.[0])
    }, [productsData?.products])

    return (
        <>
            <CardModal
                data={product}
                isOpen={cardModal}
                onClose={() => setCardModal(false)}
                onButtonClick={(product: GetProducts) => {
                    setCardModal(false)
                    onContinueClick(product)
                }}
                type="secondary"
            />
            <div className={s.mobileContent}>
                {products?.length <= 1 ? (
                    <div className={s.singleProductContent}>
                        {products.map((product, i) => (
                            <div key={product.id + i} className={s.mobileCard}>
                                <CardImage
                                    className={s.mobileImg}
                                    designId={product?.design?.id}
                                    currency={product?.currency}
                                    cardType={product?.card_type}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={s.sliderContent}>
                        <Slider
                            {...sliderSettings}
                            afterChange={() => {
                                setIsSliding(false)
                            }}
                            beforeChange={(_, i) => {
                                setIsSliding(true)
                                setProduct(products[i])
                            }}
                            ref={sliderRef}
                        >
                            {products.map((productItem, i) => (
                                <div
                                    key={productItem.id + i}
                                    className={cn(s.mobileCard, product?.id !== productItem.id && s.opacity)}
                                    onClick={() => sliderRef.current?.slickGoTo(i)}
                                >
                                    <CardImage
                                        className={s.mobileImg}
                                        designId={productItem?.design?.id}
                                        currency={productItem?.currency}
                                        cardType={productItem?.card_type}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                )}
                {product && (
                    <>
                        <div className={s.mobileTextContent}>
                            <FormattedHTMLMessage
                                id={`product.name.${product.id}`}
                                defaultMessage={product.name || ''}
                                className={s.title}
                            />
                            <FormattedHTMLMessage
                                id={`product.description.${product.id}`}
                                defaultMessage={product.description || ''}
                                className={s.description}
                            />
                        </div>
                        <div className={s.button}>
                            <Button
                                onClick={() => setCardModal(true)}
                                mode="primary"
                                size="l"
                                dataPointer="continue_button"
                                isDisabled={isSliding}
                            >
                                <FormattedHTMLMessage {...lang.continue} />
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

export default Mobile
